import { render } from "./SimpleCatalog.vue?vue&type=template&id=2d5e1c16&ts=true"
import script from "./SimpleCatalog.vue?vue&type=script&lang=ts"
export * from "./SimpleCatalog.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/waga/Projects/breil/wp-content/themes/breil/addons/packages/catalog/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__